import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import { imageUrl } from '../lib/images';

export default function LaagerPage() {
  const categories = [
    {
      title: "Kompositlåge",
      desc: "Moderne, robust og næsten vedligeholdelsesfri",
      href: "/kompositlaage",
      image: "/_assets/komposithegn-laage.webp",
    },
    {
      title: "Kompositdør",
      desc: "Skræddersyet udendørs dør eller skurdør i stålramme med komposit",
      href: "/kompositdor",
      image: "/_assets/img20251229122934.jpg",
    },
    {
      title: "Panellåge",
      desc: "Klassisk design og solid konstruktion til daglig brug",
      href: "/panellaage",
      image: "/_assets/472206536-1118964739603980-7349353629794315307-n.jpg",
    },
    {
      title: "Rionetlåge",
      desc: "Enkel, stilren og perfekt i kombination med grønne omgivelser",
      href: "/rionetlaage",
      image: "/_assets/480188274-1283354403152757-3860986236524628895-n-0.jpg",
    },
    {
      title: "Smedejernslåge",
      desc: "Elegant, tidløs og yderst holdbar løsning",
      href: "/smedejernslaage",
      image: "/_assets/smedlge1.jpeg",
    },
    {
      title: "Træbeklædte låger",
      desc: "Naturlige, stabile og æstetiske låger",
      href: "/traebeklaedte-laager",
      image: "/_assets/thumbnail-img20250926084045.jpg",
    },
  ];

  return (
    <>
      <SEO
        title="Låger – funktionalitet og æstetik i én løsning | Hovendals"
        description="Se vores brede udvalg af forskellige låger løsninger: kompositlåge smedejernslåge"
        ogImage="/_assets/480314285-1284270803061117-7582872431202638585-n.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/480314285-1284270803061117-7582872431202638585-n.jpg", "width=1600,quality=80,format=auto")}
            alt="Låger"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-door-open" aria-hidden="true"></i>
              <span>Kvalitetslåger</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Låger – funktionalitet og æstetik i én løsning
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              En låge skal både være praktisk i hverdagen og passe ind i helhedsudtrykket på din grund. Hos Hovendals tilbyder vi flere typer låger, der kombinerer styrke, holdbarhed og et flot design, så du får en løsning, der matcher både hegn og omgivelser.
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center space-y-4 mb-16">
            <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Udvalg af låger</span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
              Låger i kvalitet og design
            </h2>
            <p className="text-slate-600 leading-relaxed text-base">
              Hos Hovendal tilbyder vi låger, der kombinerer funktionalitet, sikkerhed og æstetik. Uanset om du foretrækker en moderne kompositløsning, en klassisk panellåge eller en elegant smedejernslåge, leverer vi holdbare løsninger, der matcher dit hegn og din ejendom.
            </p>
          </div>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {categories.map((c, i) => (
              <Link
                key={i}
                to={c.href}
                className="group flex flex-col rounded-2xl overflow-hidden bg-slate-50 border border-slate-200/80 shadow-sm hover:shadow-xl transition-all duration-300"
              >
                <div className="h-56 overflow-hidden bg-slate-100 relative">
                  <img
                    src={imageUrl(c.image, "width=600,quality=80,format=auto")}
                    alt={c.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/60 via-transparent to-transparent opacity-60 group-hover:opacity-80 transition-opacity"></div>
                </div>
                <div className="p-6 flex-1 flex flex-col justify-between space-y-4">
                  <div>
                    <h3 className="text-xl font-bold text-slate-900 group-hover:text-[#004fa4] transition-colors">
                      {c.title}
                    </h3>
                    <p className="text-sm text-slate-600 mt-2 leading-relaxed">
                      {c.desc}
                    </p>
                  </div>
                  <div className="inline-flex items-center gap-2 text-sm font-bold text-[#004fa4] group-hover:text-[#183e7f]">
                    <span>Læs mere</span>
                    <i className="fa-sharp fa-solid fa-arrow-right text-xs transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="p-8 rounded-2xl bg-slate-900 text-white text-center max-w-3xl mx-auto space-y-3">
            <h3 className="text-xl font-bold text-white">
              Fuldend indhegningen med den rette låge
            </h3>
            <p className="text-sm text-slate-300 leading-relaxed">
              Med en låge fra Hovendals får du en kombination af funktion, sikkerhed og et æstetisk udtryk, der fuldender indhegningen af din ejendom.
            </p>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />
    </>
  );
}
